import { whereConnectionStatusDefault } from '@vrplatform/ui-common';
import { type Query, useQuery } from '../graphql';
import { useTeam } from '../hooks/team';

export const STORYBOOK_PROPERTY_MANAGEMENT_CONNECTIONS_QUERY_KEY =
  'onboarding-property-management-connections';

export const getPropertyManagementConnections = (
  q: Query,
  args: { teamId: string },
  opts?: {
    limit?: number;
  }
) => {
  return q
    .connection({
      where: {
        status: whereConnectionStatusDefault,
        tenantId: { _eq: args.teamId },
        app: { category: { _eq: 'propertyManagementSystem' } },
      },
      order_by: [{ appId: 'asc_nulls_first' }],
      limit: opts?.limit,
    })
    .map((connection) => ({
      appId: connection.appId,
      name: connection.app.name,
      type: connection.app.type,
      category: connection.app.category,
      id: connection.id,
    }));
};

export function usePropertyManagementConnectionsQuery(
  opts?: Parameters<typeof getPropertyManagementConnections>[2]
) {
  const [{ id: teamId }] = useTeam();

  return useQuery(
    (q, { opts: queryOpts, ...args }) =>
      getPropertyManagementConnections(q, args, queryOpts),
    {
      keepPreviousData: true,
      storybookQueryKey: STORYBOOK_PROPERTY_MANAGEMENT_CONNECTIONS_QUERY_KEY,
      variables: {
        teamId,
        opts,
      },
      queryKey: ['connections'],
    }
  );
}
